export default "<base-page [pageType]=\"pageType\" [domain]=\"domain\" cors=\"true\"></base-page>\n"